import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

const messageBlockStyle = (theme: Theme) => createStyles({
    root: {
        ...theme.genie.font,
        flexWrap: "unset",
        position: "relative",
        padding: "20px 15px",
        lineHeight: "20px",
        marginBottom: "20px",
        backgroundColor: "white",
        color: "#555555",
        borderRadius: "3px",
        minWidth: "unset",
        maxWidth: "unset",
    },

    info: {
        backgroundColor: theme.genie.palette.info.dark,
        color: theme.genie.palette.info.contrastText,
    },
    success: {
        backgroundColor: theme.genie.palette.success.dark,
        color: theme.genie.palette.success.contrastText,
    },
    warning: {
        backgroundColor: theme.genie.palette.warning.dark,
        color: theme.genie.palette.warning.contrastText,
    },
    notice: {
        backgroundColor: theme.genie.palette.notice.dark,
        color: theme.genie.palette.notice.contrastText,
    },
    error: {
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
    },
    primary: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
    },
    secondary: {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.secondary.contrastText,
    },
    muted: {
        backgroundColor: theme.genie.palette.muted.main,
        color: theme.genie.palette.muted.dark,
    },
    mutedLight: {
        backgroundColor: theme.genie.palette.muted.light,
        color: theme.genie.palette.muted.dark,
    },
    mutedDark: {
        backgroundColor: theme.genie.palette.muted.dark,
        color: theme.genie.palette.muted.contrastText,
    },
    inherit: {
        color: "inherit"
    },

    flat: {
        paddingRight: Math.ceil(parseInt(theme.spacing()) / 2),
        paddingLeft: Math.ceil(parseInt(theme.spacing()) / 2),
    },

    message: {
        padding: Math.ceil(parseInt(theme.spacing()) / 2),
    },

    center: {
        textAlign: "center"
    }
});

export default messageBlockStyle;
